import { supabase } from '../supabaseClient'

export function soDigitosTelefone(raw) {
  let d = String(raw || '').replace(/\D/g, '')
  if (d.startsWith('0')) d = d.replace(/^0+/, '')
  return d
}

/** Normaliza para 55 + DDD + número (como a Meta envia no wa_id). */
export function normalizarTelefoneProposta(raw) {
  const d = soDigitosTelefone(raw)
  if (d.length === 10 || d.length === 11) return `55${d}`
  return d
}

/**
 * Chave de comparação ignorando o 9 extra do celular
 * (mesmo critério do webhook WhatsApp).
 */
export function chaveTelefoneProposta(raw) {
  const n = normalizarTelefoneProposta(raw)
  const local = n.startsWith('55') ? n.slice(2) : n
  if (local.length === 11 && local[2] === '9') {
    return local.slice(0, 2) + local.slice(3)
  }
  if (local.length >= 10) return local.slice(-10)
  return local
}

export function formatarTelefoneLiberado(raw) {
  const n = normalizarTelefoneProposta(raw)
  const local = n.startsWith('55') ? n.slice(2) : n
  if (local.length === 11) {
    return `(${local.slice(0, 2)}) ${local.slice(2, 7)}-${local.slice(7)}`
  }
  if (local.length === 10) {
    return `(${local.slice(0, 2)}) ${local.slice(2, 6)}-${local.slice(6)}`
  }
  return n || '—'
}

export function numeroEstaLiberadoProposta(lista, ...candidatos) {
  const chaves = candidatos.map(chaveTelefoneProposta).filter(Boolean)
  if (!chaves.length) return false
  return (lista || []).some((item) => chaves.includes(chaveTelefoneProposta(item.telefone)))
}

export async function listarLiberadosProposta() {
  const { data, error } = await supabase
    .from('whatsapp_proposta_liberados')
    .select('id, telefone, nome, created_at')
    .order('created_at', { ascending: false })
  if (error) return { success: false, error: error.message, itens: [] }
  return { success: true, itens: data || [] }
}

export async function adicionarLiberadoProposta({ telefone, nome }) {
  const normalizado = normalizarTelefoneProposta(telefone)
  const local = normalizado.startsWith('55') ? normalizado.slice(2) : normalizado
  if (local.length < 10 || local.length > 11) {
    return { success: false, error: 'Informe um celular com DDD (10 ou 11 dígitos).' }
  }
  const { data, error } = await supabase
    .from('whatsapp_proposta_liberados')
    .insert({
      telefone: normalizado,
      nome: String(nome || '').trim() || null
    })
    .select('id, telefone, nome, created_at')
    .single()
  if (error) {
    if (String(error.message || '').includes('duplicate') || error.code === '23505') {
      return { success: false, error: 'Este número já está liberado.' }
    }
    return { success: false, error: error.message }
  }
  return { success: true, item: data }
}

export async function removerLiberadoProposta(id) {
  const { error } = await supabase.from('whatsapp_proposta_liberados').delete().eq('id', id)
  if (error) return { success: false, error: error.message }
  return { success: true }
}
